import api from "..";
import { Order } from "../../models/Order";
import { SubscriptionDto } from "../../models/Subscription";
import { CallbackRequestDto } from "../../models/CallbackRequest";

interface CreateOrderResponse {
  success: boolean;
  message: string;
  presentationId: string;
}

export const createNewOrder = async (order: Order) => {
  return await api.post<CreateOrderResponse>(`/order/`, order);
};

export const subscribeToNewsletter = async (
  subscriptionDto: SubscriptionDto
) => {
  return await api.post(`/subscribe/`, subscriptionDto);
};

export const createCallbackRequest = async (
  callbackRequestDto: CallbackRequestDto
) => {
  return await api.post(`/callback-request/`, callbackRequestDto);
};
